<div class="historic-main-container">
    <h1>Mis puntos Shell Box</h1>
    <div class="points-container">
        <div class="points-box">
            <div class="points-total">
                <div class="points-description">
                    <span>Tus puntos</span>
                    <span class="total-points">
                        {{ formatNumber(currentUser?.context?.activities[0]?.personStatus?.accountBalance) }}
                    </span>                    
                </div>
                <img [src]="imageSrc" alt="Descarga la app">
            </div>
            <div class="user-name">
                <span>{{ userName }}</span>
                <p>Miembro de Shell Box desde {{ currentUser?.person?.profile?.birthday | date: 'dd/MM/yyyy' }}</p>
            </div>            
        </div>
    </div>
    <div *ngIf="!loading && movements.length == 0" style="text-align: center; margin-top: 50px; margin-bottom: 50px;">
        No se han encontrado movimientos
    </div>  
    <div class="history-container" *ngIf="movements.length > 0">
        <div class="history-content">
            <h2>Historial de puntos Shellbox</h2>
            <div class="history-list">
                <ng-container *ngFor="let movement of movements">
                    <div class="history-item">
                        <img [src]="getImageForDescription(movement.description1, movement.description2)" alt="image">
                        <div class="history-info">
                            <p class="history-description">
                                {{ movement?.description2 != null && movement?.description2 !== "" 
                                    ? movement.description2 
                                    : normalizeText(movement?.description1, movement?.movementType) }}
                            </p>
                            <span class="history-date">{{ movement?.date | date: 'dd/MM/yyyy' }}</span>
                        </div>
                        <span class="history-points" [ngClass]="movement.movementType == 'Credit' ? 'green' : 'red'">
                            {{ movement.movementType == 'Credit' ? '+' : '-' }} 
                            {{ (movement?.amount | number:'1.0-0')?.replace(',', '.') }} pts
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="slider-container-desktop mb-4">
        <div class="wrapper-container">
            <div class="container-desktop">
                <div class="title-overlay">
                  <h3 class="title">Seguí disfrutando de Shell Box</h3>
                  <a href="/beneficios-y-descuentos" >
                    Ver todos <img src="../../../assets/icon/icon-know-more.svg" alt="">
                  </a>
                </div>
            </div>
            <div class="swiper-wrapper">
                <app-benefits-item [dashboard]="false" [benefit]="slidersBenefit"></app-benefits-item>
            </div>
        </div>
    </div>
</div>
